<template>
  <div
    class="item-card"
    @click="routerMethod()"
    @mouseover="isHovering = true"
    @mouseout="isHovering = false"
  >
    <div class="arrow" :class="isHovering && !edit ? 'arrow-show':''">
      <div>
        <v-icon size="50px" color="#808F9C">keyboard_arrow_right</v-icon>
      </div>
    </div>
    <div class="pa-3">
      <div class="item-title mb-2">
        {{record.name}}
        
      </div>
      <div>
        created:
        <span class="text-grey">{{fromNow}}</span>
      </div>
      <div>
        Trades:
        <span class="text-grey">{{record._trades.length}}</span>
      </div>
      <div>
        P/L:
        <span :class="profitLoss < 0 ? 'loss' : 'profit'">
          <b>${{eq[eq.length-1].toFixed(2)}}</b>
        </span>
      </div>
    </div>

    <v-sparkline
    class="ma-0"
      v-if="this.record._trades.length > 0"
      :value="eq"
      :color="eq[eq.length-1] < 0 ? '#E62163' : '#79C04D'"
      line-width="2"
      smooth="10"
      padding="0"
      fill
    ></v-sparkline>
    <div v-else class="nodata mt-8">
     
    </div>
  </div>
</template>

<script>
//color="#4dbac0"
var moment = require("moment-timezone");
export default {
  name: "StrategyItem",
  props: { record: Object , edit: Boolean},
  data() {
    return {
      eq: [0],
      msg: "This is a button.",
      isHovering: false,
      fromNow: moment
        .tz(this.record.createdAt, this.$store.getters.timezone)
        .fromNow()
    };
  },
  computed: {
    profitLoss() {
      var pl = 0;
      this.record._trades.forEach(trade => {
        pl += trade.ClosedProfitLoss;
      });
      return pl;
    }
  },
  mounted() {
    this.eq = [0];
    var sum = 0
    this.record._trades.forEach(trade => {
      sum+=trade.ClosedProfitLoss
      this.eq.push(sum);
    });
    // updating record time
    setInterval(() => {
      var value = this.record.createdAt;
      this.fromNow = moment.tz(value, this.$store.getters.timezone).fromNow();
    }, 10000);
  },
  methods: {
    routerMethod() {
      if(!this.edit){
      return this.$router.push({
        name: "strategies",
        params: { name: this.$route.params.name, id: this.record._id }
      });
      }
    },
    deleteData(value) {
      if (localStorage.getItem("access_token")) {
        var apiData = {
          action: "remove",
          component: "Strategies",
          id: value
        };
        this.$store
          .dispatch("API_COMPONENT_REQUESTS", apiData)
          .then(() => {})
          .catch(() => {
            alert(
              "API failed. Component: " +
                apiData.component +
                ", Action: " +
                apiData.action
            );
          });
      }
    }
  }
};
</script>

<style scoped>
.nodata {
  text-align: center;
  padding-top: 40px;
}

.item-card {

  border-radius: 3px;
  font-size: 12px;
  font-family: "Roboto", sans-serif;
  cursor: pointer;
  transition: 0.5s;
}
.item-card:hover {
  background: #232a35;
}

.arrow {
  position: absolute;
  right: -60px;
  padding-top: 65px;
  text-align: center;
  height: 100%;
  width: 60px;
  background-color: rgba(0, 0, 0, 0.3);
  transition: 0.5s;
}
.arrow-show {
  right: 0%;
}
</style>